import { ChevronRightOutlined, ExpandMoreOutlined } from '@mui/icons-material';
import { GRID_DETAIL_PANEL_TOGGLE_COL_DEF } from '@mui/x-data-grid-pro';
import { useMemo } from 'react';

import {
  DescriptionDetailRecordCell,
  DescriptionDetailRecordCellProps,
} from '../../cells/DescriptionDetailRecordCell/DescriptionDetailRecordCell';

export const useDataGridMasterDetailConfig = <T extends DescriptionDetailRecordCellProps>() => {
  return useMemo(
    () => ({
      getDetailPanelContent: ({ row }: { row: T }) => DescriptionDetailRecordCell(row),
      getDetailPanelHeight: () => 'auto',
      slots: {
        detailPanelExpandIcon: ChevronRightOutlined,
        detailPanelCollapseIcon: ExpandMoreOutlined,
      },
      defaultToggleColumnDefinition: GRID_DETAIL_PANEL_TOGGLE_COL_DEF,
    }),
    [],
  );
};
